import vert from './glsl/horizonHaze.vert.glsl';
import frag from './glsl/horizonHaze.frag.glsl';
export default { frag, vert };
